angular.module('admin')
  .controller('AgentRealEstateAgentsCtrl', ['$scope', '$state', '$rootScope', 'AgentService', function($scope, $state, $rootScope, AgentService){

    $scope.agentId =  $state.params.id;

    $scope.state = $state;

    $scope.currentMlsPro = null;
    $scope.currentSponsoredAgent = null;

    var reAgentWatch = $rootScope.$on('$stateChangeSuccess', updateCurrentAgent);

    $scope.$on('$destroy', reAgentWatch); // removes from $rootScope

    function getAgent(){
      AgentService.getOne($scope.agentId)
        .then((result) => {
          $scope.agent = result;
        })
        .catch(onError);
    }

    function getMlsPro(mlsset){
      AgentService
        .realEstateAgents($scope.agentId, mlsset)
        .then(function(result){
          $scope.currentMlsPro = result;
        })
        .catch(onError);
    }

    function getSponsoredAgent(sponsoredAgentId){
      AgentService
        .getSponsoredAgent($scope.agentId, sponsoredAgentId)
        .then(function(result){
          $scope.currentSponsoredAgent = result;
        })
        .catch(onError);
    }

    function updateCurrentAgent(event, toState, toParams){
      $scope.currentMlsPro = null;
      $scope.currentSponsoredAgent = null;

      if(toParams.mlsset)
        return getMlsPro(toParams.mlsset);

      if(toParams.sponsoredAgentId)
        return getSponsoredAgent(toParams.sponsoredAgentId);
    }

    function onError(e){
      $scope.error = e;
    }

    function init(){
      if($state.params.mlsset)
        getMlsPro($state.params.mlsset);

      if($state.params.sponsoredAgentId)
        getSponsoredAgent($state.params.sponsoredAgentId);

      getAgent();
    }

    init();

  }]);
